import { FC } from 'react';

import { TextField } from '@shared/components/TextField';
import AutoComplete from '@shared/containers/AutoComplete/AutoComplete';
import { Control, UseFormRegister } from 'react-hook-form';

const phraseCondolenceList: string[] = [
  '삼가 故人의 冥福을 빕니다',
  '삼가 고인의 명복을 빕니다',
  '謹弔',
  '천국에서 편히 쉬소서',
  '주님의 위로가 함께 하소서',
  '極樂往生發願',
  '극락왕생발원',
];

interface IProps {
  register: UseFormRegister<any>;
  control: Control<any, any>;
  names: {
    phraseSender: string;
    phraseCondolence: string;
  };
  //* 긴 체크아웃 폼에선 입력칸을 화면 위로 끌어올리는 게 도움이 되지만,
  //* 모달 안에서는 뒤 페이지가 멋대로 스크롤돼 방해만 된다 — 모달에선 false.
  scrollOnFocus?: boolean;
}

const PhraseInfoInputs: FC<IProps> = ({
  register,
  control,
  names: { phraseSender, phraseCondolence },
  scrollOnFocus = true,
}: IProps) => {
  return (
    <div className="font-bold">
      <h4>문구 작성</h4>
      <div className="grid grid-cols-1 grid-rows-2 gap-y-3 pt-3">
        <TextField
          className="w-full"
          placeholder="보내는 사람 (서울대학교 동문 일동)"
          scrollOnFocus={scrollOnFocus}
          {...register(phraseSender, { required: true })}
        />
        <AutoComplete
          placeholder="조의문구 선택 및 직접 입력"
          optionList={phraseCondolenceList}
          control={control}
          name={phraseCondolence}
        />
      </div>
    </div>
  );
};

export default PhraseInfoInputs;
